// ExistingCustomerStep1.jsx
import React from 'react'
import PropTypes from 'prop-types'

import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'

import {
  CapitalButton,
} from '../../Navigation/Buttons'

import NewModemDefault from '../../Graphics/ModemSwapGraphics/NewModem'
import Incorrect1Default from '../../Graphics/ModemSwapGraphics/Incorrect1'
import Incorrect2Default from '../../Graphics/ModemSwapGraphics/Incorrect2'
import CorrectDefault from '../../Graphics/ModemSwapGraphics/Correct'
import SeatModemDefault from '../../Graphics/ModemSwapGraphics/SeatModem'
import ReplaceAntennaDefault from '../../Graphics/ModemSwapGraphics/ReplaceAntenna'
import DisposalDefault from '../../Graphics/ModemSwapGraphics/Disposal'
import ReconnectPowerDefault from '../../Graphics/ModemSwapGraphics/ReconnectPower'

// HOC
import withAppStore from '../../../../util/withAppStore'

import styles from '../../../../../css/home.module.css'
import settingStyles from '../../../../../css/settings.module.css'

const ModemReplacementStep3 = ({
  intl: { formatMessage },
  nextPage,
  skipInstructions,
}) => {
  return (
    <div>
      {skipInstructions}
      <div className={`${styles.userInviteInput} ${settingStyles.modemReplacementContainer}`}>
        <FormattedMessage
          id='settings.modemReplacement.installModem'
          defaultMessage='INSTALLING THE 4G MODEM: '
          description='Installing The 4g Modem label'
          tagName='h3'
        />

        <div className={settingStyles.modemReplacementIntro}>
          <p>
            <FormattedMessage
              id='settings.modemReplacement.disconnectingPowerIntro'
              defaultMessage='Video and text instructions available '
              description='Diconnecting Power Intro label'
            />
            <a className={styles.replacementLink} href='https://altrac.zendesk.com/hc/en-us/articles/360038363473-ST100-Repair-Maintenance' target='_blank' rel='noreferrer'>
              <FormattedMessage
                id='settings.modemReplacement.hereLink'
                defaultMessage='here'
                description='Here Link label'
              />
              .
            </a>
          </p>
        </div>

        <div className={settingStyles.ModemSVGWrapper}>
          <NewModemDefault />
        </div>
        <FormattedMessage
          id='settings.modemReplacement.newModemStep1'
          defaultMessage='1. Grab the new modem on top and bottom as shown above.  The micro USB port should be pointing towards the Control Line entry point.'
          description='New Modem Step One label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <Incorrect1Default />
        </div>
        <div className={settingStyles.ModemSVGWrapper}>
          <Incorrect2Default />
        </div>
        <div className={settingStyles.ModemSVGWrapper}>
          <CorrectDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.newModemStep2'
          defaultMessage='2. Line the modem up using the pins as shown above.  Partially seat the pins and take your hand away.  There should be no overhanging pins on either side of the modem.'
          description='New Modem Step Two label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <SeatModemDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.newModemStep3'
          defaultMessage='3. If no pins are overhanging replace your fingers at the top and bottom of the modem and push in until fully seated.'
          description='Step Three label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <ReplaceAntennaDefault />
        </div>
        <FormattedMessage
          id='settings.modemReplacement.newModemStep4'
          defaultMessage='4. Replace the antenna by seating the antenna head over the port and pressing straight down.'
          description='Step Four label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <ReconnectPowerDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.newModemStep6'
          defaultMessage='5. Reconnect the 12-pin connector at the end of the control line from hardware.'
          description='Step Six label'
          tagName='p'
        />
        <div className={settingStyles.ModemSVGWrapper}>
          <DisposalDefault />
        </div>

        <FormattedMessage
          id='settings.modemReplacement.newModemStep5'
          defaultMessage='6. Dispose of old modem.  Please consider using e-waste recycling.'
          description='Step Five label'
          tagName='p'
        />

      </div>

      <CapitalButton
        text={formatMessage({
          id: 'customer.nextButton',
          defaultMessage: 'Next',
          description: '',
        })}
        buttonFunction={nextPage}
        hSize='h2'
        style={`${styles.saveButton} saveButton`}
      />
    </div>
  )
}

ModemReplacementStep3.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  nextPage: PropTypes.func.isRequired,
  skipInstructions: PropTypes.node,
}

export default withAppStore(injectIntl(ModemReplacementStep3))
